import React from 'react'
import { Spin } from 'antd'

import styled from 'styled-components'

const Container = styled.div`
    display: flex;

    flex-direction: column;

    align-items: center;
    justify-content: center;

    text-align: center;
    padding: 16px;

    height: 200px;
`

function Loader ()
{
    return (
        <Container>
            <Spin />
        </Container>
    )
}

export default Loader